import React, { FC } from "react";

import { TOverviewCarouselIndicatorsProps } from "../../types/OverviewCarousel.type";

const OverviewCarouselIndicators: FC<TOverviewCarouselIndicatorsProps> = ({
  numOfSlides,
  currentSlideIndex,
}) => {
  const items: Array<number> = Array(numOfSlides).fill(null);

  return (
    <ul className="series-overview-carousel__indicators">
      {items.map((_, index) => (
        <li
          className={`series-overview-carousel__indicators__item${
            index === currentSlideIndex
              ? " series-overview-carousel__indicators__item--active"
              : ""
          }`}
          key={`overview-slider-indicators-item-${index}`}
        ></li>
      ))}
    </ul>
  );
};

export default OverviewCarouselIndicators;
